export const MainLight = () => {
    return (
        <div className="absolute top-0 end-0 -z-[1] opacity-50">
            <svg width="786" height="720" viewBox="0 0 786 720" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_135_13173)">
                    <ellipse
                        cx="62.6057"
                        cy="85.0569"
                        rx="460.316"
                        ry="280.405"
                        transform="rotate(30 62.6057 85.0569)"
                        fill="#2C93F3"
                        fillOpacity="0.3"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_f_135_13173"
                        x="-660.09"
                        y="-549.522"
                        width="1445.39"
                        height="1269.16"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_135_13173" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};
export const HomeLight = () => {

    return (
        <div className="absolute top-0 end-0 z-10">
            <svg width="786" height="720" viewBox="0 0 786 720" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5" filter="url(#filter0_f_135_6759)">
                    <ellipse
                        cx="62.6057"
                        cy="85.0569"
                        rx="460.316"
                        ry="280.405"
                        transform="rotate(30 62.6057 85.0569)"
                        fill="#2C93F3"
                        fillOpacity="0.3"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_f_135_6759"
                        x="-660.09"
                        y="-549.522"
                        width="1445.39"
                        height="1269.16"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_135_6759" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};
export const FooterLight = ({ className }: { className?: string }) => {
    return (
        <div className={`absolute bottom-0 start-0 ${className}`}>
            <svg width="629" height="415" viewBox="0 0 629 415" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.5" filter="url(#filter0_f_845_29198)">
                    <ellipse
                        cx="722.847"
                        cy="634.995"
                        rx="460.316"
                        ry="280.405"
                        transform="rotate(30 722.847 634.995)"
                        fill="#2C93F3"
                        fillOpacity="0.3"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_f_845_29198"
                        x="0.151367"
                        y="0.416199"
                        width="1445.39"
                        height="1269.16"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feGaussianBlur stdDeviation="150" result="effect1_foregroundBlur_845_29198" />
                    </filter>
                </defs>
            </svg>
        </div>
    );
};
